//
// サンクスメール設定画面
//
document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName("form-thanks-mail");
  if (pages.length == 0) return;

  const previewSubject = document.querySelector("[data-preview-subject]");
  const previewBody = document.querySelector("[data-preview-body]");
  const clearForm = document.querySelector("[data-clear-form]");

  const inputSubject = document.querySelector(
    "#service_thanks_mail_attributes_subject"
  );
  const inputBody = document.querySelector(
    "#service_thanks_mail_attributes_body"
  );

  // inputの入力内容をpreview側に反映
  [
    [previewSubject, inputSubject],
    [previewBody, inputBody],
  ].forEach(([previewArea, inputField]) => {
    previewArea.textContent = inputField.value;

    ["keyup", "change"].forEach((eventName) => {
      inputField.addEventListener(eventName, (event) => {
        previewArea.textContent = event.target.value;
      });
    });
  });

  // フォーム内容のクリア
  clearForm.addEventListener("click", (_event) => {
    let changeEvent = new Event("change", { bubbles: true, cancelable: true });

    [inputSubject, inputBody].forEach((element) => {
      element.value = "";
      element.dispatchEvent(changeEvent);
    });
  });
});
